import { render, staticRenderFns } from "./user_role.vue?vue&type=template&id=07d7e234&scoped=true"
import script from "./user_role.vue?vue&type=script&lang=js"
export * from "./user_role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7e234",
  null
  
)

export default component.exports